import React from 'react';
import { Redirect, Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import PrivateRoute from './private-route'

import { Layout } from 'antd';

/**
 * ACTIONS
 */
import { checkIfLoggedin } from './components/user/actions';
import { setUserIdEmailMap } from './components/admin/actions';
import { addSupplierFromSocket, getSuppliers } from './components/supplier/actions';
import { updateOrder } from './components/orders/actions';
import { getBrands } from './components/brands/actions';

/**
 * COMPONENTS
 */
import Sidebar from './components/sidebar';

import Toolbar from './components/toolbar';

import { _getAdmins } from './services';

import { routes } from './routes'

/**
 * IMAGES
 */
import ezLogo from './assets/eezee-logo.png';
import ezLogoSquare from './assets/eezee-logo-square.png';

/**
 * SERVICES
 */
import {_getTrackEvent} from './services'

const { Content, Sider } = Layout;

class App extends React.Component{

	render(){

		const { user } = this.props;

    if( this.state.hasError ){
      return (
        <p style={{whiteSpace: "pre-line"}}>
          {this.state.stack} <br/>
          {this.state.errorInfo.componentStack}
        </p>
      )
    }

		if(user.loading){
			return <div>Fetching admin...</div>
		}

		if(!user.data && !user.loading && user.loginUrl){
			return window.location.href = user.loginUrl;
		}

		if((!user.data.permissions || !user.data.permissions.ezAdmin) && !user.loading && user.loginUrl){
			return window.location.href = user.loginUrl;
		}

		return (
			<Layout className="page-container">

				{/*<Toolbar />*/}
				<Sider 
					className="side-bar"
					collapsed={this.state.collapsed}
					onCollapse={this.onCollapse}
					>

					<div className="toolbar-ez-logo" >
						<img alt="Eezee Logo" src={this.state.collapsed?ezLogoSquare:ezLogo}/>
					</div>
					<Sidebar ezSuperuser={user.data.permissions && user.data.permissions.ezSuperuser} collapsed={this.state.collapsed}/>

				</Sider>

				<Layout style={{width: "100%"}}>
					
					<Content style={{overflow:'scroll'}}>


						<div>
							<Toolbar />
							
							<Switch>
								{routes.map( _route => (
									<PrivateRoute 
										exact 
										path={_route.path}
										component={_route.component}
										/>
								))}
								
								{/* <PrivateRoute exact path="/supplier/add" component={SupplierPage} /> */}
								{/* <PrivateRoute exact path="/supplier/add" component={SupplierPage} /> */}
								{/* <PrivateRoute exact path="/" component={<div>aasdf</div>} />
								<PrivateRoute path="/" component={ ()=><div>404</div>} /> */}

							</Switch>
						</div>

					</Content>
				</Layout>

			</Layout>
		)
	}
	
	
  componentDidCatch(error, errorInfo) {
	  
    // Display fallback UI
    // this.setState({ 
    //   hasError: true, 
    //   errorInfo, 
    //   stack: error.stack
    // });
    
  }

  componentDidUpdate(prevProps) {	

	if ( (this.props.location.pathname !=  prevProps.location.pathname) || (this.props.location.search !=  prevProps.location.search) ) {
		_getTrackEvent({
			ev:"VIEWED_PAGE_ADMIN", 
			medium:this.props.location.pathname, 
		})
	}

  }


	constructor(props){
		super(props);

		this.state = {
			hasError: false,
			collapsed: false,
			errorInfo: {},
			stack: []
		}

		_getAdmins()
			.then( res => {
				let userIdEmailMap = {};

				for (let i = 0; i < res.data.users.length; i++) {
					const user = res.data.users[i];
					userIdEmailMap[user._id] = user.local.email;
				}

				this.props.setUserIdEmailMap( userIdEmailMap );

			})

		this.props.getSuppliers();
		this.props.getBrands();
		this.props.checkIfLoggedin();		

		/**
		 * @todo
		 */
		// props.socket.on('ADD_GHOST_SUPPLIER', supplier => this.props.addSupplierFromSocket(supplier));
		// props.socket.on('UPDATE_ORDER', this.props.updateOrder);
	}

	onCollapse = (collapsed) => {
		this.setState({
			collapsed
		})
	}

}

export default connect(
	state => ({
		user: state.user
	}),

	dispatch => ({
		//orders
		updateOrder: (order) => dispatch(updateOrder(order)),

		// supplier
		addSupplierFromSocket: (supplier) => dispatch(addSupplierFromSocket(supplier)),
		getSuppliers: () => dispatch(getSuppliers()),

		// brands
		getBrands: () => dispatch(getBrands()),

		// user
		checkIfLoggedin: () => dispatch(checkIfLoggedin()),
		setUserIdEmailMap: ( userIdEmailMap ) => dispatch( setUserIdEmailMap( userIdEmailMap ) )
	})

)( withRouter(App) );


// WEBPACK FOOTER //
// ./src/app.js